import React from "react";
import ListagemAval from "../ListagemAval";

const Listagens: React.FC = () => {
	return <ListagemAval />;
};

export default Listagens;
